module.exports = __webpack_public_path__ + "static/DifficultyDifficultGames5-a8563fdcf1be7ecc709292efe9705332.webp";